import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import shallow from "zustand/shallow";
import { t } from "@lingui/macro";

import { i18n } from "base/i18n";
import { getFormattedDate } from "base/utils";
import { Modal } from "widgets/modal";
import { SearchInput, SEARCH_TYPE } from "widgets/inputs";
import { UserIcon, AVATAR_SIZE } from "widgets/datadisplay";

import { usePostStore } from "../../common/store/post.store";
import { PostService } from "../../common/service/post.service";
import { ProfileSkeletonLoader } from "../skeleton_loader";
import { sortPostViewsArray } from "../../common/utils/utils";

import styles from "./reaction.css";

PostViewsModal.propTypes = {
  title: PropTypes.node,
  onClose: PropTypes.func,
  medium: PropTypes.string,
  teamId: PropTypes.string,
  mediumId: PropTypes.string,
  instanceId: PropTypes.string
};

export function PostViewsModal({
  title,
  onClose,
  medium,
  mediumId,
  teamId,
  instanceId
}) {
  const { postViewMembers } = usePostStore(
    (state) => ({
      postViewMembers: state.postViewMembers
    }),
    shallow
  );

  const [viewedMembers, setViewedMembers] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(
    function getPostViewedMembers() {
      setLoading(true);
      let getPostViewedResponse = PostService.getPostViewedMember(
        teamId,
        mediumId,
        instanceId
      );
      getPostViewedResponse
        .onResponse((data) => {
          usePostStore.setState({
            postViewMembers: {
              postId: instanceId,
              data: sortPostViewsArray(data)
            }
          });
          setLoading(false);
        })
        .onError((err) => {
          console.info(err);
          setLoading(false);
        });
      return () => {
        getPostViewedResponse.cancel();
      };
    },
    [teamId, mediumId, instanceId]
  );

  useEffect(
    function searchPostViewsMembers() {
      if (!searchValue) {
        setViewedMembers(postViewMembers.data);
      } else {
        let value = searchValue.toLocaleLowerCase().normalize().trim();
        setViewedMembers(filterSearch(value, postViewMembers.data));
      }
    },
    [postViewMembers.data, postViewMembers.postId, searchValue]
  );

  function filterSearch(value, users) {
    return users.filter((user) =>
      user.Name.toLocaleLowerCase().normalize().trim().includes(value)
    );
  }
  return (
    <Modal
      title={title}
      open={true}
      closeOnOutsideClick={true}
      width={"50rem"}
      heigth={"45rem"}
      onClose={(e) => {
        e.stopPropagation();
        onClose();
      }}
      footerRenderer={() => null}
    >
      <div className={styles.searchContainer}>
        <SearchInput
          type={SEARCH_TYPE.NORMAL}
          placeholder={i18n._(t`Search members`)}
          value={searchValue}
          onClear={() => {
            setSearchValue("");
          }}
          onChange={(e) => {
            e.stopPropagation();
            setSearchValue(e.target.value);
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      <div className={styles.viewsUsersContainer}>
        {loading ? (
          <div>
            <ProfileSkeletonLoader />
            <ProfileSkeletonLoader />
            <ProfileSkeletonLoader />
            <ProfileSkeletonLoader />
          </div>
        ) : (
          viewedMembers.map((item) => (
            <div className={styles.viewsDataContainer} key={item._id}>
              <div className={styles.reactionimageWrapper}>
                <UserIcon
                  size={AVATAR_SIZE.SIZE36}
                  name={item.Name}
                  userId={item._id}
                />
              </div>
              <div className={`base ${styles.viewsProfileData}`}>
                <p>{item.Name}</p>
                <p>{getFormattedDate(item.SeenAt, "DD MMM YYYY, h:mm a")}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </Modal>
  );
}
